import React from "react";
import { intl } from "../../../i18n/TypedIntl";
import { AutoComplete } from "../autoComplete/autoComplete";
import styles from "./languagePicker.css";

export enum LanguageOption {
  Polish = "pl-PL",
  English = "en-GB"
}

interface Props {
  onChange: (value: LanguageOption) => void;
  currentLanguage: LanguageOption;
}

export const LanguagePicker = ({ onChange, currentLanguage }: Props) => {
  const mapLanguageToString = (language: LanguageOption | null) => {
    switch (language) {
      case LanguageOption.Polish:
        return intl.formatMessage("language.polish");
      case LanguageOption.English:
        return intl.formatMessage("language.english");
      default:
        return "";
    }
  };

  return (
    <AutoComplete<LanguageOption>
      className={styles["language-picker"]}
      onChange={onChange}
      itemsProvider={() => Object.values(LanguageOption)}
      itemToString={mapLanguageToString}
      readOnly
      inputValue={mapLanguageToString(currentLanguage)}
    />
  );
};

export const getLanguageOption = (fragment?: string): LanguageOption | undefined => {
  return fragment
    ? Object.values(LanguageOption).find((option) => option.includes(fragment))
    : undefined;
};

export const getLanguageOptionWithDefault = (fragment?: string): LanguageOption => {
  return getLanguageOption(fragment) || LanguageOption.English;
};

export const getLanguageOptionFromBrowser = () => {
  switch (navigator.language.split("-")[0]) {
    case "pl":
      return LanguageOption.Polish;
    default:
      return LanguageOption.English;
  }
};
